import axios from 'axios';

const API_URL = 'https://qwikbistro.shop';
const TOKEN = process.env.REACT_APP_QWIK_BISTRO_API_TOKEN;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const ingredientApiService = {
  // Get all ingredients
  getAllIngredients: async () => {
    try {
      const response = await axiosInstance.get('/ingredientCost/');
      return response.data.reverse(); // Latest first
    } catch (error) {
      console.error('Error fetching ingredients:', error);
      throw error;
    }
  },

  // Get single ingredient
  getIngredient: async (id) => {
    try {
      const response = await axiosInstance.get(`/ingredientCost/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ingredient:', error);
      throw error;
    }
  },

  // Update ingredient
  updateIngredient: async (id, ingredientData) => {
    try {
      const response = await axiosInstance.put(`/ingredientCost/${id}`, ingredientData);
      return response.data;
    } catch (error) {
      console.error('Error updating ingredient:', error);
      throw error;
    }
  },

  // Delete ingredient
  deleteIngredient: async (id) => {
    try {
      await axiosInstance.delete(`/ingredientCost/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting ingredient:', error);
      throw error;
    }
  },

  // Create new ingredient
  createIngredient: async (ingredientData) => {
    try {
      const response = await axiosInstance.post('/ingredientCost/new', ingredientData);
      return response.data;
    } catch (error) {
      console.error('Error creating ingredient:', error);
      throw error;
    }
  },
};